<template>
	<v-form @submit.prevent="addRequest">
		<v-container>
			<div v-if="feedback == 0">
				<v-row class="contentRow" align="center">
					<v-col cols="12">
						<h1 class="mb-2">Request Audit Flow-Down From a Supplier</h1>
						<p class="mb-10 text-center">
							This is where you can send an audit request to a supplier
						</p>
					</v-col>
					<v-col cols="12">
						<v-stepper class="elevation-0" v-model="step">
							<v-stepper-header class="elevation-0">
								<v-stepper-step
									:editable="step != 4"
									edit-icon="fas fa-check"
									:complete="step > 1 || step == '2a' || step == '2b'"
									step="1"
								>
									Select Template
								</v-stepper-step>
								<v-divider />
								<v-stepper-step
									:editable="
										(step > 2 || step == '2a' || step == '2b') && step != 4
									"
									edit-icon="fas fa-check"
									:complete="step > 2 || step == '2a' || step == '2b'"
									step="2"
								>
									Choose Recipient
								</v-stepper-step>
								<v-divider />

								<!-- <v-stepper-step
									step="2a"
									:complete="step > 2 && (!!recipient || !!invitationCode)"
								>
									Choose Existing
								</v-stepper-step>
								<v-divider />

								<v-stepper-step
									step="2b"
									edit-icon="fas fa-check"
									:complete="step > 2 && !!invitationCode"
								>
									Invite Supplier
								</v-stepper-step>
								<v-divider /> -->

								<v-stepper-step
									:editable="step > 3 && step != 4"
									edit-icon="fas fa-check"
									step="3"
								>
									Summary
								</v-stepper-step>
								<v-divider />

								<v-stepper-step step="4"> Result </v-stepper-step>
							</v-stepper-header>

							<v-stepper-content height="200px" step="1">
								<v-text-field label="Template"  item-value="value" v-model="templateName" style="margin-top: 10px;" outlined></v-text-field>
								<p class="mt-0 font-italic" style="display: flex">
									<v-checkbox
										v-model="sendToSupplier"
										:disabled="!templateID" 
										class="mt-0 pt-0"
									>
									</v-checkbox>
									Send this flow-down template to your supplier/s
								</p>
								<v-row>
									<v-col class="text-right">
										<v-btn 
											color="secondary"
											class="mr-2" 
											:disabled="!templateID" 
											@click="showPreview()"
										>
										Preview Template <v-icon small right>fas fa-eye</v-icon>
										</v-btn>
										<v-btn 
											v-if="sendToSupplier"
											color="primary"
											:disabled="!templateID" 
											@click="step = 2"
											>
											Next<v-icon right>fas fa-arrow-right</v-icon>
										</v-btn>
										<v-btn 
											v-else
											color="primary"
											
											:to="'/auditflowdown/flowdownsubmitter/'"
											>
											End
										</v-btn>
									</v-col>
								</v-row>
							</v-stepper-content>

							<v-stepper-content step="2">
								<v-row>
									<v-col cols="12">
										<v-btn depressed color="secondary" @click="step = '2a'"
											>Choose Existing Supplier</v-btn
										>
										<v-btn
											outlined
											color="secondary"
											depressed
											class="ml-3"
											@click="
												step = '2b';
												$store.dispatch(
													'connections/invitationcodes/setInvitationCodeModalOpen',
													true
												);
											"
										>
											<v-icon left>fas fa-plus</v-icon>Add New Supplier
										</v-btn>
									</v-col>
								</v-row>
								<v-row>
									<v-col class="text-left">
										<v-btn
											color="primary"
											outlined
											:disabled="step == 1 || step == 4"
											@click="previousStep"
										>
											<v-icon left>fas fa-arrow-left</v-icon> Previous Step
										</v-btn>
									</v-col>
									<v-col class="text-right">
										<v-btn 
											color="primary"
											:disabled="true"
										>
										Next<v-icon right>fas fa-arrow-right</v-icon>
										</v-btn>
									</v-col>
								</v-row>
							</v-stepper-content>

							<v-stepper-content step="2a">
								<v-card class="elevation-0">
									<v-card-title>Choose Recipient</v-card-title>
									<v-card-subtitle
										>Please choose either a connection or an invitation code as a
										recipient for the audit request</v-card-subtitle
									>
									<v-card-text>
										<v-select
											:items="filteredConnection"
											label="Connections"
											v-model="selectedRecipients"
											multiple
										>
											<template v-slot:prepend-item>
												<v-list-item>
													<v-list-item-content>
														<v-text-field 
															v-model="connectionSearch" 
															placeholder="Search Connection" 
															autofocus
															append-icon="fa fa-close"
															@click:append="clearSearch('connectionSearch')"
														></v-text-field>
													</v-list-item-content>
												</v-list-item>
											</template>
											<template v-slot:selection="{ item, index }">
												<v-chip v-if="index === 0">
													<span>{{ item.text }}</span>
												</v-chip>
												<span
													v-if="index === 1"
													class="
														grey--text
														text--darken-3
														caption
													"
												>
													(+{{ selectedRecipients.length - 1 }}
													others)
												</span>
											</template>
										</v-select>
										<b>or / and</b>
										<v-select
											:items="filteredInvitationCode"
											label="Invitation Codes"
											item-value="value"
											v-model="selectedInvitationCodes"
											multiple
											:menu="isDropdownOpen"
										>
											<template v-slot:prepend-item>
																							
												<v-list-item>
													<v-list-item-content>
														<!-- <v-btn 
															color="primary"
															style="position: fixed; top: 10px; right: 10px;"
															@click="closeDropdown" 
														>
															Close
														</v-btn> -->
														<v-text-field 
															v-model="invitationCodeSearch" 
															placeholder="Search Invitation Code" 
															autofocus
															append-icon="fa fa-close"
															@click:append="clearSearch('invitationCodeSearch')"
														>
														</v-text-field>
														
													</v-list-item-content>
												</v-list-item>
											</template>
											<template v-slot:selection="{ item, index }">
												<v-chip v-if="index === 0">
													<span>{{ item }}</span>
												</v-chip>
												<span
													v-if="index === 1"
													class="
														grey--text
														text--darken-3
														caption
													"
												>
													(+{{ selectedInvitationCodes.length - 1 }}
													others)
												</span>
											</template>
										</v-select>
									</v-card-text>
								</v-card>
								<v-row>
									<v-col class="text-left">
										<v-btn
											color="primary"
											outlined
											class="ml-4"
											:disabled="step == 1 || step == 4"
											@click="previousStep"
										>
											<v-icon left>fas fa-arrow-left</v-icon> Previous Step
										</v-btn>
									</v-col>
									<v-col class="text-right">
										<v-btn
											depressed
											class="mr-4"
											:disabled="
												selectedInvitationCodes.length == 0 &&
													selectedRecipients.length == 0
											"
											color="secondary"
											@click="step = '3'"
											>
											Next<v-icon right>fas fa-arrow-right</v-icon>
										</v-btn>
									</v-col>
								</v-row>
							</v-stepper-content>

							<v-stepper-content step="2b">
								<!-- <v-btn
									outlined
									color="secondary"
									class="mb-2"
									depressed
									@click="
										$store.dispatch(
											'connections/invitationcodes/setInvitationCodeModalOpen',
											true
										)
									"
								>
									<v-icon left>fas fa-plus</v-icon>Add New Supplier
								</v-btn> -->
								<AddNewInvitationCode
									:isAuditRequestReceiver="true"
									@updateInvitationCode="updateInvitationCode"
								/>
								<NewCodeDisplay />
								<v-row>
									<v-col class="text-left">
										<v-btn
											color="primary"
											outlined
											:disabled="step == 1 || step == 4"
											@click="previousStep"
										>
											<v-icon left>fas fa-arrow-left</v-icon> Previous Step
										</v-btn>
									</v-col>
									<v-col class="text-right">
										<v-btn
											color="primary"
											@click="step = 3"
											:disabled="selectedInvitationCodes.length == 0"
										>
											Next<v-icon right>fas fa-arrow-right</v-icon>
										</v-btn>
									</v-col>
								</v-row>
							</v-stepper-content>

							<v-stepper-content step="3">
								<v-card class="elevation-0" style="border: 2px solid #227e85;" align="center">
									<v-card-title style="font-weight: bold; color: #227e85; margin-left: 44%;">Summary</v-card-title>
									<v-card-subtitle>
										Review the details of the request below.
									</v-card-subtitle>
									<v-card-text class="text--primary">
										<p class="mb-1"> 
											Template: 
											<b
												>'{{
													templateID
														? templates.filter(t => {
																return t.value == templateID
														})[0].text
														: ""
												}}'</b
											>
											<!-- (ID: {{ templateID }}) -->
										</p>
										<p v-if="selectedRecipients.length > 0">
											will be sent to client{{
												selectedRecipients.length > 1 ? "s" : ""
											}}: '<b>{{
												connections.filter(t => {
													return t.value == selectedRecipients[0]
												})[0].text
											}}</b
											>'
											<span v-if="selectedRecipients.length > 1"
												>(+
												{{ selectedRecipients.length - 1 }}
												others)</span
											>
										</p>
										<p v-if="selectedInvitationCodes.length > 0">
											will be sent to invitation code{{
												selectedInvitationCodes.length > 1 ? "s" : ""
											}}: '<b>{{ selectedInvitationCodes[0] }}</b
											>'
											<span v-if="selectedInvitationCodes.length > 1"
												>(+
												{{ selectedInvitationCodes.length - 1 }}
												others)</span
											>
										</p>
										<p></p>
									</v-card-text>
								</v-card>
								<v-row>
									<v-col class="text-left">
										<v-btn
											color="primary"
											outlined
											:disabled="step == 1 || step == 4"
											@click="previousStep"
										>
											<v-icon left>fas fa-arrow-left</v-icon> Previous Step
										</v-btn>
									</v-col>
									<v-col class="text-right">
										<v-btn
											color="primary"
											type="submit"
											@click="step = 4"
											align="center"
										>
											Send Request{{
												selectedRecipients.length +
													selectedInvitationCodes.length >
												1
													? "s"
													: ""
											}}
											<v-icon right>fas fa-paper-plane</v-icon>
										</v-btn>
									</v-col>
								</v-row>
							</v-stepper-content>

							<v-stepper-content step="4">
								<div v-if="!error">
									<!-- <v-icon color="success" class="mx-auto" x-large
									>fas fa-check-circle</v-icon
									> -->
									<div style="border: 2px solid #227e85;" align="center">
										<v-img
											alt="Success Icon"
											:src="require('../../assets/twemoji/success.svg')"
											width="75"
											class="mx-auto my-8"
										/>
										<!-- <h2>Success</h2> -->
										<p class="mb-4" style="font-size: 20px;">Successfully sent audit request!</p>
									</div>
									<v-row>
										<v-col class="text-left">
											<v-btn
												color="secondary"
												:to="{ name: 'Audit Flow-Down Overview' }"
												align="center"
											>
											Go To Auditor View
											<v-icon right>fas fa-external-link-alt</v-icon>
											</v-btn>
										</v-col>
										<v-col class="text-right">
											<v-btn color="primary" @click="resetForm" align="center">
											Send Another Request
												<v-icon right>fas fa-plus</v-icon>
											</v-btn>
										</v-col>
									</v-row>
								</div>
								<div v-else>
									<div style="border: 2px solid red;" align="center">
										<v-icon color="error" class="mx-auto" x-large
											>fas fa-times-circle</v-icon
										>
										<h2>Error</h2>
										<p>Could not complete audit request!</p>
										<p>{{ error }}</p>
									</div>
									<v-btn color="error" @click="resetForm" align="center">
										Send New Request
										<v-icon right>fas fa-undo-alt</v-icon>
									</v-btn>
								</div>
								<div style="border: 1px solid #227e85; border-radius: 10px; margin-top: 20px">
									<v-col cols="12" class="pt-10 pr-15 pl-15">
										<p>At Orixe, we believe that ethical supply chains are the foundation of a sustainable future. By fostering transparency and trust, we enable businesses to not only
											meet today's demands for accountability but also lead the way in creating a positive legacy for people and the planet.</p>
										<v-col align="center">
											<v-btn outlined class="ma-2 white--text" color="primary" @click="commentBoxOpen = true" v-if="!isFeedbackGiven">Give your feedback</v-btn>
											<!--<v-btn dark color="orangeButton" class="ma-2" @click="getFreeAcc()">GET A FREE TRAIL</v-btn>-->
										</v-col>
									</v-col>
								</div>
							</v-stepper-content>
						</v-stepper>
					</v-col>
				</v-row>
				<v-dialog v-model="dialog" max-width="500px">
					<v-card>
						<v-card-title>Choose Recipient</v-card-title>
						<v-card-subtitle
							>Please choose either a connection or an invitation code as a
							recipient for the audit request</v-card-subtitle
						>
						<v-card-text>
							<v-select
								:items="connections"
								label="Connections"
								v-model="selectedRecipients"
								multiple
							>
								<template v-slot:selection="{ item, index }">
									<v-chip v-if="index === 0">
										<span>{{ item }}</span>
									</v-chip>
									<span v-if="index === 1" class="grey--text caption">
										(+{{ selectedRecipients.length - 1 }}
										others)
									</span>
								</template>
							</v-select>
							<v-autocomplete
								:items="invitationCodes"
								label="Invitation Codes"
								item-value="value"
								v-model="invitationCode"
							></v-autocomplete>
						</v-card-text>
						<v-card-actions>
							<v-btn color="primary" text v-on:click="dialog = false" outlined
								>Select</v-btn
							>
						</v-card-actions>
					</v-card>
				</v-dialog>
				<v-dialog 
					v-model="dialogPreview"
					max-width="1200px"
					height="auto"
					scrollable
					align = "center">
					<v-card>
						<v-card-actions class="pt-7 pr-8" style="justify-content: flex-end">
							<v-btn 
								class="success"
								color="white" 
								text 
								@click="dialogPreview = false; preview = false" 
								outlined
							>Close</v-btn
							>
						</v-card-actions>
						<v-card-text class="background-color: white">		
							<template-preview v-if="preview"
								:previewID="templateID"
								:preview="true"
							/>
						</v-card-text>
						
					</v-card>
				</v-dialog>
				<v-dialog v-model="commentBoxOpen" persistent max-width="600">
					<v-card>
						<v-col>
							<v-card-title>How was your overall experience using the Orixe platform?</v-card-title>
							<v-btn icon :color="platform === 1 ? 'orangeButton' : 'primary'" class="ma-8" @click="platformComment(1)" large><v-icon large>far fa-sad-tear</v-icon></v-btn>
							<v-btn icon :color="platform === 2 ? 'orangeButton' : 'primary'" class="ma-8" @click="platformComment(2)" large><v-icon large>far fa-frown</v-icon></v-btn>
							<v-btn icon :color="platform === 3 ? 'orangeButton' : 'primary'" class="ma-8" @click="platformComment(3)" large><v-icon large>far fa-meh</v-icon></v-btn>
							<v-btn icon :color="platform === 4 ? 'orangeButton' : 'primary'" class="ma-8" @click="platformComment(4)" large><v-icon large>far fa-smile</v-icon></v-btn>
							<v-btn icon :color="platform === 5 ? 'orangeButton' : 'primary'" class="ma-8" @click="platformComment(5)" large><v-icon large>far fa-laugh</v-icon></v-btn>
						</v-col>
						<v-col>
							<v-card-title>How was is to navigate in the platform?</v-card-title>
							<v-btn icon :color="navigation === 1 ? 'orangeButton' : 'primary'" class="ma-8" @click="navigationComment(1)" large><v-icon large>far fa-sad-tear</v-icon></v-btn>
							<v-btn icon :color="navigation === 2 ? 'orangeButton' : 'primary'" class="ma-8" @click="navigationComment(2)" large><v-icon large>far fa-frown</v-icon></v-btn>
							<v-btn icon :color="navigation === 3 ? 'orangeButton' : 'primary'" class="ma-8" @click="navigationComment(3)" large><v-icon large>far fa-meh</v-icon></v-btn>
							<v-btn icon :color="navigation === 4 ? 'orangeButton' : 'primary'" class="ma-8" @click="navigationComment(4)" large><v-icon large>far fa-smile</v-icon></v-btn>
							<v-btn icon :color="navigation === 5 ? 'orangeButton' : 'primary'" class="ma-8" @click="navigationComment(5)" large><v-icon large>far fa-laugh</v-icon></v-btn>
						</v-col>
						<v-col>
							<v-card-title>How was your experience completing the task?</v-card-title>
							<v-btn icon :color="task === 1 ? 'orangeButton' : 'primary'" class="ma-8" @click="taskComment(1)" large><v-icon large>far fa-sad-tear</v-icon></v-btn>
							<v-btn icon :color="task === 2 ? 'orangeButton' : 'primary'" class="ma-8" @click="taskComment(2)" large><v-icon large>far fa-frown</v-icon></v-btn>
							<v-btn icon :color="task === 3 ? 'orangeButton' : 'primary'" class="ma-8" @click="taskComment(3)" large><v-icon large>far fa-meh</v-icon></v-btn>
							<v-btn icon :color="task === 4 ? 'orangeButton' : 'primary'" class="ma-8" @click="taskComment(4)" large><v-icon large>far fa-smile</v-icon></v-btn>
							<v-btn icon :color="task === 5 ? 'orangeButton' : 'primary'" class="ma-8" @click="taskComment(5)" large><v-icon large>far fa-laugh</v-icon></v-btn>
						</v-col>
						<v-col>
							<v-card-title>Do you have any suggestions for improvement?</v-card-title>
							<v-card-text>
								<!-- Your comment box content goes here -->
								<v-textarea v-model="comment"></v-textarea>
							</v-card-text>
						</v-col>
						<v-card-actions>
							<v-btn @click="submitComment()" color="primary">Submit</v-btn>
							<v-btn @click="commentBoxOpen = false" color="primary">Cancel</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</div>
			<v-row v-else-if="feedback == 1" class="contentRow pr-15 pl-15">
				<v-col cols="12" class="pl-15 pr-15">
					<v-card-actions class="justify-end">
						<v-icon class="pl-1 pr-1" color="primary" @click="cancelFeedback()" style="border: 1px solid ;">fas fa-thin fa-times</v-icon>
					</v-card-actions>
					<v-img alt="Success Icon" :src="require('../../assets/twemoji/success.svg')" width="70" class="mx-auto my-8" />
					<h2 class="mb-5">Thank You for Your Feedback!</h2>
					<p>We truly appreciate you taking the time to share your thoughts. Your input helps us make Orixe more effective and user-friendly.</p>
					<p>At Orixe, we believe transparency and accountability are essntial for a better future.</p>
					<p>Supply chains impact the environment, human rights, and resources -- but often lack the visibility needed for responsible management.</p>
					<p>Together we're working towards ethical, sustainable supply chains that build trust and drive progress.</p>
					<p>Thank you for being part of this journey!</p>
				</v-col>
				<v-col cols="12" align="center">
					<v-btn class="ma-2 white--text" color="primary" to="/ProductPlan">UPGRADE MY ACCOUNT</v-btn>
				</v-col>
			</v-row>
			<v-dialog v-model="exitDialog" max-width="700">
				<v-card cols="12" class="pa-10">
					<v-card-actions class="justify-end">
						<v-icon class="pl-1 pr-1" color="primary" @click="cancelExit()" style="border: 1px solid ;">fas fa-thin fa-times</v-icon>
					</v-card-actions>
					<p>"At Orixe, we believe businesses are the world's most influential institutions. Their decisions shape supply chains, 
						communities, and ecosystems, impacting lives and economies. However, the complexity of global supply chains often makes it 
						challenging to ensure ethical practices and minimize environmental harm.</p>
					<p>We believe this challenge can be addressed by combining advanced technology with core values like integrity, accountability, and fairness, 
						enabling organizations to act decisively and effectively."</p>
				</v-card>
			</v-dialog>
		</v-container>
	</v-form>
</template>

<script>
import LoadingState from "../../consts/LoadingState"
import ConnectionAPI from "../../api/connections/connection"
import TemplateAPI from "../../api/audit/template"
import RequestAPI from "../../api/audit/request"
import AddNewInvitationCode from "../../components/InvitationCodes/AddNew"
import NewCodeDisplay from "../../components/InvitationCodes/NewCodeDisplay"
import InvitationCodesAPI from "../../api/connections/invitationcodes"
import FlowDownTemplatePreview from "./FlowDownTemplatePreview.vue"
export default {
	name: "RequestAuditFlowDown",
	components: {
		AddNewInvitationCode,
		NewCodeDisplay,
		"template-preview" : FlowDownTemplatePreview,
	},
	data() {
		return {
			step: 1,
			dialog: false,
			dialogPreview: false,
			//Placeholder Data
			templates: [
				{
					text: "Loading templates...",
					value: "test" /*disabled: true*/
				}
			],
			connections: [
				{
					text: "Loading connections...",
					value: "test" /*disabled: true*/
				}
			],
			invitationCodes: [],
			recipient: null,
			templateID: null,
			invitationCode: null,
			selectedRecipients: [],
			selectedInvitationCodes: [],
			inviteCodeDialog: false,
			expirydate: 0,
			error: null,
			preview: false,
			templateSearch: "",
			connectionSearch: "",
			invitationCodeSearch: "",
			isDropdownOpen: true,
			sendToSupplier: true,
			flowDownFromAudit:0,
			templateName:null,
			commentBoxOpen: false,
			navigation: null,
			platform: null,
			task: null,
			isFeedbackGiven: false,
			feedback: 0,
			exitDialog: false,
		}
	},
	mounted() {
		this.getFeedbackData()
		this.templateID= this.$route.params.templateID
		this.flowDownFromAudit=this.$route.params.FlowDownAuditId
		this.templateName=this.$route.params.templateName
		this.loadConnections()
		this.loadTemplates()
		this.loadInvitations()
		this.getTemplate(this.$route.params.templateID)
	},
	computed: {
		filteredTemplates() {
			if (!this.templateSearch) {
				return this.templates
			}

			return this.templates.filter((template) => {
				return template.text.toLowerCase().indexOf(this.templateSearch.toLowerCase()) > -1
			})
		},
		filteredConnection() {
			if (!this.connectionSearch) {
				return this.connections
			}

			return this.connections.filter((connection) => {
				return connection.text.toLowerCase().indexOf(this.connectionSearch.toLowerCase()) > -1
			})
		},
		filteredInvitationCode() {
			if (!this.invitationCodeSearch) {
				return this.invitationCodes
			}

			return this.invitationCodes.filter((invitationCode) => {
				return invitationCode.text.toLowerCase().indexOf(this.invitationCodeSearch.toLowerCase()) > -1
			})
		},
	},
	methods: {
		platformComment(selected) {
			this.platform = selected
			this.commentBoxOpen = true
		},
		navigationComment(selected) {
			this.navigation = selected
		},
		taskComment(selected) {
			this.task = selected
		},
		getFeedbackData(){
			let currentTime = new Date()
			RequestAPI.getFeedback()
				.then(result => {
					for (let entry of result) {
						if( entry.Module == 2){
							let submittedTime = new Date(entry.SubmitTime)
							let different = Math.floor((currentTime - submittedTime) / (1000 * 60 * 60 * 24))

							if(different < 60){
								this.isFeedbackGiven = true
							}
						}
					}
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		submitComment() {
			let id = this.$route.params.templateID
			let submitTime = new Date().toISOString().slice(0, 19).replace("T", " ")
			let module = this.$route.path.split("/")[1]
			
			RequestAPI.submitFeedback(id,submitTime,this.platform,this.navigation,this.task,this.comment,module)
				.then( () => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						`Successfully submit the feedback`,
						{ root: true }
					)
					this.commentBoxOpen = false
				})
				.catch(error => {
					this.error = error
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
			this.commentBoxOpen = false
			this.feedback = 1
		},
		cancelFeedback(){
			this.exitDialog = true
		},
		cancelExit(){
			this.exitDialog = false
			this.$router.push("/")
		},
		getFreeAcc(){
			this.$router.push("/ProductPlan")
		},
		clearSearch(searchField) {
			this[searchField] = "" 
		},
		updateInvitationCode(updatedInvitationCode) {
			this.selectedInvitationCodes.push(updatedInvitationCode)
			if (updatedInvitationCode) {
				this.selectedRecipients = []
			}
		},
		loadConnections() {
			ConnectionAPI.getConnections()
				.then(data => {
					this.connections = []
					for (let entry of data) {
						this.connections.push({
							value: entry.clientID,
							text: `${entry.name}`,
							remove: null
						})
					}
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		loadInvitations() {
			InvitationCodesAPI.list({ hasBeenRedeemed: false })
				.then(data => {
					this.invitationCodes = []
					for (let entry of data.items) {
						this.invitationCodes.push({
							text: `${entry.name} (${entry.invitationCode})`,
							value: entry.invitationCode
						})
					}
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		loadTemplates() {
			if(this.$route.params.templateID!=0){
				this.templates = []
				this.templates.push({
					value: this.$route.params.templateID,
					text: this.$route.params.templateName,
					remove: null
				})
			}else{
				TemplateAPI.getActiveTemplates(1)
					.then(data => {
						console.log(data)
						this.templates = []
						for (let entry of data.data) {
							this.templates.push({
								value: entry.ID,
								text: `${entry.Name}`,
								remove: null
							})
						}
					})
					.catch(error => {
						this.$store.dispatch(
							"loading/" + LoadingState.ACTION_SET_ERROR,
							error,
							{ root: true }
						)
					})
			}
			console.log(this.templates)
		},
		getTemplate(t) {
			TemplateAPI.getTemplate(24)
			console.log("data",t)
				.then(data => {
					console.log("ddddddddddddd",data)
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		addRequest() {
			console.log("fdg",this.templateID)
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			RequestAPI.addRequest(
				this.templateID,
				this.selectedRecipients,
				this.selectedInvitationCodes,
				this.expirydate,
				this.flowDownFromAudit,
				null,
				null,
				null,
				null
			)
				.then(data => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						`Successfully sent an audit request with ID '${data}' to recipients`,
						{ root: true }
					)
					this.templateID = null
					this.recipient = null
					this.error = null
				})
				.catch(error => {
					this.error = error
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		resetForm() {
			this.recipient = null
			this.invitationCode = null
			this.templateID = null
			this.step = 1
			this.error = null
		},
		previousStep() {
			if (this.step == 1 || this.step > 3) {
				return
			} else if (this.step == 2) {
				this.step = 1
			} else if (this.step == "2a" || this.step == "2b") {
				this.step = 2
			} else if (this.step == 3) {
				this.step = 2
			}
		},
		showPreview() {
			this.preview = true
			this.dialogPreview = true
		},
	}
}
</script>
